import React, { useState,useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TextField, Button, Box, Typography, Paper } from "@mui/material";
import { apiMain } from "../../App";
import { PostDataPromise ,GetDataPromise} from "../Functions/SendingData";


export default function BookingRegister(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mailflag, setMailFlag] = useState(false);
  const [passflag, setPassFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      // پاک کردن localStorage و sessionStorage
  localStorage.removeItem('email');  // اگر قبلاً ایمیل در localStorage ذخیره شده باشد
  sessionStorage.removeItem('email');
    setEmail('');
    setPassword('');
  }, []);
  
  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (!email ) {
      alert("Please fill in email field");
      return;
    }

    try {
      setLoading(true);
      let uparams = new URLSearchParams();
      uparams.append("email", email);
      console.log(uparams.toString());  // چک کن که URL درست ساخته بشه
   //   console.log("Request URL:", `${apiMain}/api/v1/users/sendCode?${uparams}`);
      const res1 = await GetDataPromise(`${apiMain}/api/v1/users/sendCode?${uparams}`,true);
      const parsed1 = JSON.parse(res1);

      if (parsed1.status === "success") {
        alert("Your password has been sent to your email..");
        setMailFlag(true);
        setPassFlag(true);

        // navigate("/");
      } else {
        alert("Error: " + parsed1.message);
      }
    } catch (error) {
      alert("Unexpected error while resetting password.");
    } finally {
      setLoading(false);
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!password ) {
      alert("Please fill in password field");
      return;
    }

    try {
      setLoading(true);
      let uparams = new URLSearchParams();
      uparams.append("U_Name", email);
      uparams.append("U_Password", password);

  //const U_id=    localStorage.getItem("U_id");
  const res = await GetDataPromise(`${apiMain}/api/v1/users/select?${uparams}`,true);
      const parsed = JSON.parse(res);

      if (parsed.status === "success") {
        props.changeLoginFlag(false);
        props.ChangeEmail(email)
        props.changereservFlag(true);
        localStorage.setItem('U_Token',parsed.data[0].U_Token); 
        localStorage.setItem('U_Name',parsed.data[0].U_Name); 
        localStorage.setItem('U_id',parsed.data[0].U_id); 
      } else {
        alert("Error: " + parsed.message);
      }
    } catch (error) {
      alert("Unexpected error while resetting password.");
    } finally {
      setLoading(false);
    }
  };

    //  alert(`Registered with: ${fullname}, ${email}, ${password}`);
    //  navigate("/");


  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
      <Paper elevation={3} sx={{ p: 4, width: 430, borderRadius: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Register
        </Typography>
        <form onSubmit={handleRegister}>
        {/*   <TextField
            fullWidth
            margin="normal"
            label="Full Name"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
            required
          /> */}

          <TextField
            fullWidth
            margin="normal"
            type="email"
            disabled={mailflag}
            label="Enter your email address "
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="off"  // اضافه کردن این ویژگی
          />
         <Button
          fullWidth 
          disabled={mailflag}
          type="submit" 
          variant="contained"
           sx={{ mt: 2 }}>
                             Continue with email
          </Button>
          <TextField
            fullWidth
            disabled={!passflag}
            margin="normal"
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          //  required
          />
    <Button 
    fullWidth
    disabled={!passflag}
     onClick={handleLogin}
      variant="contained"
       sx={{ mt: 2 }}>
                             Login
          </Button>
        </form>


      </Paper>
    </Box>
  );

}
